import { gql } from "urql";
export const GetChatRoomsQuery = gql `
    query GetChatRooms($type: ChatRoomTypeEnum, $isArchived: Boolean) {
        chatRooms {
            rooms(type: $type, isArchived: $isArchived) {
                chatRoomId
                type
                name
                description
                isGroupDm
                isArchived
                lastMessageAt
                createdByUserId
                caregiverId
                patientId
                createdAt
                unreadCount
                lastMessage {
                    chatMessageId
                    contentText
                    senderUserId
                    senderFirstName
                    senderLastName
                    createdAt
                }
                members {
                    chatRoomMemberId
                    userId
                    firstName
                    lastName
                    email
                    imageUrl
                    lastReadAt
                    isMuted
                    joinedAt
                }
            }
        }
    }
`;
export const GetChatRoomQuery = gql `
    query GetChatRoom($chatRoomId: String!) {
        chatRooms {
            room(chatRoomId: $chatRoomId) {
                chatRoomId
                type
                name
                description
                isGroupDm
                isArchived
                lastMessageAt
                createdByUserId
                caregiverId
                patientId
                createdAt
                unreadCount
                members {
                    chatRoomMemberId
                    userId
                    firstName
                    lastName
                    email
                    imageUrl
                    lastReadAt
                    isMuted
                    joinedAt
                }
            }
        }
    }
`;
export const SearchChatMessagesQuery = gql `
    query SearchChatMessages($query: String!, $limit: Int) {
        chatRooms {
            search(query: $query, limit: $limit) {
                message {
                    chatMessageId
                    contentText
                    senderFirstName
                    senderLastName
                    createdAt
                    chatRoomId
                }
                room {
                    chatRoomId
                    name
                    type
                }
            }
        }
    }
`;
